import React, { ComponentPropsWithoutRef } from 'react'
import * as Styled from './InlineLabel.styles'

interface CustomProps {
  /**
   * Label contents
   */
  label?: React.ReactNode
}

export type ComponentProps = CustomProps & ComponentPropsWithoutRef<'label'>

const InlineLabel: React.FC<ComponentProps> = ({ children, label, ...props }) => (
  <Styled.Label {...props}>
    {children}
    <Styled.LabelText>{label}</Styled.LabelText>
  </Styled.Label>
)

export default InlineLabel
